import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { AuthService } from './_services/auth.service';
import { UserSessionDataForm } from './_models/login/user-session-data-form';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  userDataSession;
  userDisplayName = '';
  userRoleId = 0;
  userRoleName = '';
  userDetailsId = 0;
  loading: boolean = true;
  registerUrl: string;
  currentUrl: string;

  constructor(
    private authService: AuthService,
    private router: Router) {
    this.registerUrl = location.pathname;
    router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    }
    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.loading = false;
    }
  }

  ngOnInit() {
    this.authService.checkUserSession();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userRoleId = this.userDataSession.userRoleId;
      this.userDetailsId = this.userDataSession.userDetailsId;
      if (this.userDataSession.fullName) {
        this.userDisplayName = this.userDataSession.fullName;
      } else if (this.userDataSession.emailId) {
        this.userDisplayName = this.userDataSession.emailId;
      }
      this.userRoleName = this.userDataSession.userRoleName;

      if (this.userRoleId == 1) {
        this.router.navigate(['/main/dashboard']);
      }
      else if (this.userRoleId == 2 && this.registerUrl === '/main/patentFilingProcess') {
        this.router.navigate(['/main/patentFilingProcess'])
      }
      else if (this.userRoleId == 2 && this.registerUrl !== '/main/patentFilingProcess') {
        this.router.navigate(['/main/dashboardUser']);
      }
    }
    else if (this.registerUrl === "/register") {
      this.router.navigate(['/register']);
    }
    else if (this.registerUrl === '/main/patentFilingProcess') {
      this.router.navigate(['/main/patentFilingProcess'])
    }
    else {
      this.router.navigate(['/login']);
    }
  }
}
